
const data = {
    title: "Menangkan Nintendo SWITCH, GRATIS!",
    description: "<p>Menangkan 2 konsol game Nintendo SWITCH untuk Advertiser dan Influencer yang memiliki poin terbanyak di akhir periode awards pada tanggal 31 Desember 2019",
    deadline: "31/12/2019",
    image: "https://s3.amazonaws.com/assets.mockflow.com/app/wireframepro/company/Cd822e2f98bd0e91c0dc7ef1425caa001/projects/M798d223246b293d042213ecebef3dbf91553054540893/images/Me1cdd70a13713396798cf763323482331560411549550"
}


export function awardsReducer(state = {
    data
}, action){
    switch(action.type){
        default: 
            return state
    }
}

export function awardsRanks(state = {
    data: {
        advertiser: [],
        influencers: [],
    },
    isPending: true
}, action){
    switch(action.type){
        case "GET_AWARDS_FULFILLED":
            return Object.assign({}, state, {
                data: action.payload.data.results,
                isPending: false
            })
        case "GET_AWARDS_PENDING":   
            return Object.assign({}, state, {
                data: {
                    advertiser: [],
                    influencers: [],
                },
                isPending: true
            })     
        default:
            return state
    }
}

export function awardsPoints(state = {
    data: {},
    isPending: true,
}, action){
    switch(action.type){
        case "GET_POINTS_FULFILLED":
            return Object.assign({}, state, {
                data: action.payload.data.results,
                isPending: false,
            })
        case "GET_POINTS_PENDING":   
            return Object.assign({}, state, {
                data: {},
                isPending: true
            })     
        default:
            return state
    }
}

export function awardsHistory(state = {
    data: {
        advertisers: [{
        avatar: "https://s3-id-jkt-1.kilatstorage.id/sosiago/profiles/admin/19266/1556467907.png",
        brand_name: "Mister Aladin",
        id: 19266,
        point: "80",
        province: "Dki Jakarta",
    }], 
        influencers: [{
        avatar: "https://s3-id-jkt-1.kilatstorage.id/sosiago/uploads/profiles/35/1539846482.png",
        id: 35,
        name: "Mochammad Ramdhan",
        point: "182",
        province: "Jawa Barat",
    }]
}
},action){
    switch(action.type){
        case "GET_AWARDS_HISTORY_FULLFILLED":
            return state;
        default:
            return state;
    }
}